var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area-chart-wrap"},[(_vm.approvalAreaList.length)?_c('ECharts',{staticClass:"chart",attrs:{"options":_vm.options,"autoresize":""}}):_c('div',{staticClass:"non-data"},[_vm._v("暂无数据")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }